<template lang="pug">
  div
    p.xs-12.max-at-tweak.f-primary(v-if="isCustomerHardAuthenticated") You're already subscribed

    p.xs-12.max-at-tweak.f-primary(v-else-if="subscribed") You're on the list!

    template(v-else)
      transition(name="fade")
        EmailCaptureForm(type="footer" theme="flat" submit-label="Notify Me" input-label="EMAIL ADDRESS...")
</template>

<script>
  import EmailCaptureForm from '../EmailCaptureForm';
  import { mapGetters, mapState } from "vuex";

  export default {
    name: "EmailCaptureBlock",

    components: {
      EmailCaptureForm,
    },

    computed: {
      title() {
        if (this.subscribed || this.isCustomerHardAuthenticated) {
          return 'THANKS FOR SUBSCRIBING!';
        }
        return 'SIGN UP FOR OUR NEWSLETTER';
      },

      ...mapGetters('customer', [
        'isCustomerHardAuthenticated',
      ]),

      ...mapState('emailCapture', [
        'subscribed',
      ]),
    },
  };
</script>
